<nav class="pagination ">
  <h3 class="is--hidden">Paginering</h3>
  <ul class="pagination-list">
    <li class="pagination-list-item type-prev" *ngIf="currentPage > 0">
      <a
        class="button  type-icon-only"
        [routerLink]="'/' + prefix"
        [queryParams]="{ page: currentPage - 1 }"
        [queryParamsHandling]="'merge'"
        rel="prev"
      >
        <span class="icon is--icon-arrow-left">
          <svg class="icon-svg">
            <use xlink:href="/assets/gfx/svg-sprite.svg#icon-arrow-left"></use>
          </svg>
        </span>
      </a>
    </li>

    <li class="pagination-item pagination-link-divider">{{ currentPage + 1 }} / {{ pages() | round }}</li>

    <li class="pagination-list-item type-next" *ngIf="currentPage + 1 < pages()">
      <a
        class="button type-icon-only"
        [routerLink]="'/' + prefix"
        [queryParams]="{ page: currentPage + 1 }"
        [queryParamsHandling]="'merge'"
        rel="next"
      >
        <span class="icon is--icon-arrow-right">
          <svg class="icon-svg">
            <use xlink:href="/assets/gfx/svg-sprite.svg#icon-arrow-right"></use>
          </svg>
        </span>
      </a>
    </li>
  </ul>
</nav>
